import { atom } from 'recoil';
import { localStorageEffect } from 'services/storage/localStorage';

export const campaignWhatsAppConfirmAtom = atom<boolean>({
  key: 'campaignWhatsAppConfirmAtom',
  default: false,
  effects: [localStorageEffect('campaignWhatsAppConfirmAtom')]
});

export const campaignLaunchConfirmAtom = atom<boolean>({
  key: 'campaignLaunchConfirmAtom',
  default: false,
  effects: [localStorageEffect('campaignLaunchConfirmAtom')]
});
